import { API } from '@/shared/api/modules';
import type { GetPayerDistributionRequestDto } from '@/shared/api/modules/facilities';
import { queryOptions } from '@tanstack/react-query';

export const getPayerDistributionQueryOptions = (
  params: GetPayerDistributionRequestDto
) =>
  queryOptions({
    queryKey: ['payer-distribution', params],
    queryFn: async ({ signal }) => {
      const response = await API.facilities.getPayerDistribution(params, {
        signal,
      });

      return response;
    },
    enabled: !!params.from && !!params.to,
  });
